(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@sage/sbc.core.authentication.ui"), require("@sage/sbc.core.scene.ui"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@sage/sbc.core.authentication.ui", "@sage/sbc.core.scene.ui", "react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@sage/sbc.core.authentication.ui"), require("@sage/sbc.core.scene.ui"), require("react")) : factory(root["@sage/sbc.core.authentication.ui"], root["@sage/sbc.core.scene.ui"], root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE__3580__, __WEBPACK_EXTERNAL_MODULE__432__, __WEBPACK_EXTERNAL_MODULE__9155__) {
return 